// extracted by mini-css-extract-plugin
export default {"spoiler":"g5Q5IADH","_isBordered":"v4Lm5AW3","_isOpened":"QlRzOZLB","title":"MmuS9RKJ","arrow":"zYPEIBvG","content":"XP1wr_Ow"};